<hr />
<div class="feedback">
    <div *ngIf="!feedbackEnviado">

        <h2 *ngIf="!mostrarTextBox">Esse artigo foi útil?</h2>
        
        <div *ngIf="!mostrarTextBox" class="button-group">
            <button class="thumb-button positivo" type="thumbs-up"  (click)="enviarComentario(true,'')">
              <i class="fa fa-thumbs-up fa-lg"></i> <span>Sim</span>
            </button>
            <button class="thumb-button negativo" type="thumbs-down"  (click)="abrirTextBox()">
              <i class="fa fa-thumbs-down fa-lg"></i> <span>Não</span>
            </button>
        </div>

        <div *ngIf="mostrarTextBox" class="description">
            <label for="description">Como podemos melhorar? (comentário opcional)</label>
            <div class="textarea-container">
                <textarea
                  #descriptionRef
                  id="description"
                  rows="3"
                  placeholder="Escreva aqui..."
                  [(ngModel)]="comentario">
                </textarea>
                <div class="contador-barra"
                  [ngClass]="{'contador-invalido': comentario.length > 1000 || (comentario.length > 0 && comentario.length < 10)}">
                  {{ comentario.length }}/1000
                </div>
            </div>
            <div class="button-group">
                <button class="submit-button" type="button" (click)="fecharTextBox()">Cancelar</button>
                <button class="submit-button" type="button" (click)="enviarComentario(false, descriptionRef.value)">Enviar</button>
            </div>
        </div>
    </div>
    
    <div *ngIf="feedbackEnviado" class="mensagem-sucesso">
        <h2 class="final">✅ Obrigado pelo seu feedback!</h2>

        <div *ngIf="!feedbackPositivo" >
            <h2 class="final-extra">Sua opinião nos ajuda a melhorar. 🫂</h2>
        </div>
    </div>
</div>